import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import { LiveInput, InputRow } from './inputsDemoHelpers';

// Static option lists — real selects load these from the backend; here they are inline
// so the control renders without a service call.
const SELECT_OPTIONS = [
  { label: 'Choose one…', value: '', disabled: true },
  { label: 'Apollo', value: 1, disabled: false },
  { label: 'Prism', value: 2, disabled: false },
  { label: 'RMX', value: 3, disabled: false },
];

const MULTI_OPTIONS = [
  { label: 'Retail', value: 1 },
  { label: 'Hospitality', value: 2 },
  { label: 'Automotive', value: 3 },
  { label: 'Banking', value: 4 },
];

function InputsSelectDemoComponent() {
  return (
    <div>
      <InputRow label='Select — single choice with static options'>
        <LiveInput
          type={InputTypesEnum.Select}
          fieldName='demoSelect'
          labelText='Source system'
          selectValues={SELECT_OPTIONS}
        />
      </InputRow>
      <InputRow label='MultiChoice — multiple choice with static options'>
        <LiveInput
          type={InputTypesEnum.MultiChoice}
          fieldName='demoMultiChoice'
          labelText='Industries'
          selectValues={MULTI_OPTIONS}
          initialValue={[]}
        />
      </InputRow>
      <InputRow label='FileUploadField — file picker'>
        <LiveInput
          type={InputTypesEnum.FileUploadField}
          fieldName='demoFile'
          labelText='Attachment'
        />
      </InputRow>
    </div>
  );
}

export const inputsSelectDemo = {
  id: 'inputs-selects',
  title: 'Selects & multi-choice',
  category: 'Inputs',
  importPath: 'src/Elements/InputComponents/InputWithClear.js (type=Select / MultiChoice / FileUploadField)',
  notes: [
    'Select and MultiChoice take their options via the selectValues prop ([{ label, value, disabled }]). Every data-bound select in the app is one of these two controls with its options fetched from the backend instead of passed inline — see the “Data-bound selects” entry.',
    'Select shows a type-ahead filter once the list passes showSelectFilterAt (default 10) options.',
    'A Select defaulting to an empty/unmatched value shows the first option; add a { value: "", disabled: true } placeholder (as above) to force a deliberate pick.',
  ],
  snippet:
    "<InputWithClear\n  type={InputTypesEnum.Select}\n  fieldName='SourceId'\n  labelText='Source system'\n  selectValues={[{ label: 'Apollo', value: 1 }, …]}\n  value={value}\n  onChange={(fieldName, v) => setValue(v)}\n/>",
  render: InputsSelectDemoComponent,
};
